import Analytics from 'analytics';
import googleTagManager from '@analytics/google-tag-manager';

export default {
    name: 'gtm',

    hooks: {
        app: {
            init() {
                this.addLib(
                    'analytics',
                    Analytics({
                        app: appData.name || document.location.host,
                        plugins: [
                            googleTagManager({
                                containerId: appData.page.vars.gtm.containerId,
                            }),
                        ],
                    })
                );
            },
        },
        page: {
            init() {
                // GTM page event.
                this.lib.analytics.page();
            },
        },
    },

    methods: {
        app: {
            trigger(name, data = {}) {
                // Expect to have a global user data.
                data.user = appData.user;
                data.url = window.location.href;
                data.event = name;

                this.lib.analytics.track(name, data);

                console.log(`~ GTM ${name} ~`);
                console.log(data);
            },
        },
    },
};
